export default "__VITE_ASSET__Dg3gJY6___"